import { create } from "zustand";
import { persist } from "zustand/middleware";

type FontScale = 1 | 1.15;

interface FontScaleState {
  fontScale: FontScale;
  setFontScale: (scale: FontScale) => void;
}

function applyFontScale(scale: FontScale) {
  const root = document.documentElement;
  if (scale === 1) {
    root.style.removeProperty("font-size");
  } else {
    root.style.fontSize = `${scale * 100}%`;
  }
}

export const useFontScaleStore = create<FontScaleState>()(
  persist(
    (set) => ({
      fontScale: 1 as FontScale,
      setFontScale: (scale: FontScale) => {
        applyFontScale(scale);
        set({ fontScale: scale });
      },
    }),
    {
      name: "pw-font-scale",
      onRehydrateStorage: () => (state) => {
        if (state?.fontScale) applyFontScale(state.fontScale);
      },
    },
  ),
);
